module.exports = __webpack_public_path__ + "static/media/student1.d8686495.png";